import {
  LocalStorageService,
  type UserPreferencesLocalStorage,
} from '@/shared/lib/storages';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import type { UserPreferences } from './types';

type UserPreferencesState = UserPreferences;

type UserPreferencesActions = {
  toggleSidebar: () => void;
};

const initialState: UserPreferencesState = {
  sidebarIsOpened:
    LocalStorageService.getUserPreferences()?.sidebarIsOpened ?? true,
};

export const useUserPreferencesStore = create<
  UserPreferencesState & UserPreferencesActions
>()(
  immer(
    persist(
      (set) => ({
        ...initialState,
        toggleSidebar: () =>
          set((state) => {
            state.sidebarIsOpened = !state.sidebarIsOpened;
          }),
      }),
      {
        name: LocalStorageService.KEYS.userPreferences,
        skipHydration: true,
        partialize: ({ sidebarIsOpened }) =>
          ({ sidebarIsOpened }) as UserPreferencesLocalStorage,
      }
    )
  )
);
